<template>
  <v-app>
    <header-simple />

    <v-content>
      <v-container class="grid-list-md">
        <v-layout layout row wrap>
          <v-flex xs12 md6 class="text-xs-center mt-5">
            <div
              v-if="settings.PUBLIC_CLIENT_REGISTER_TEXT&&settings.PUBLIC_CLIENT_REGISTER_TEXT.value"
              v-html="settings.PUBLIC_CLIENT_REGISTER_TEXT.value"
            ></div>
            <div v-else>
              <h2
                class="mb-3 font-weight-light display-1 teal--text"
              >Aktywuj {{ system.cardName.biernik }}</h2>

              <p class="headline font-weight-light">
                Z {{ system.cardName.narzednik }} skorzystaj
                <br />z bogatej oferty kulturalnej, sportowej.
              </p>
            </div>
            <v-spacer></v-spacer>

            <v-btn
              depressed
              large
              dark
              round
              mb-5
              color="error"
              :to="{name: 'register'}"
            >Zarejestruj się</v-btn>
          </v-flex>

          <v-flex xs12 md6 class="mt-5">
            <v-form @submit.prevent="tryToLogin">
              <v-card class="elevation-0 pb-3">
                <v-toolbar class="elevation-0">
                  <v-toolbar-title
                    class="font-weight-light primary--text"
                  >Jesteś posiadaczem {{ system.cardName.dopelniacz }}?</v-toolbar-title>
                </v-toolbar>

                <v-alert
                  v-model="showError"
                  class="mt-3 mx-3"
                  type="error"
                  outline
                >{{ errorMessage }}</v-alert>

                <v-card-text>
                  <w-schema :model="$schema.login">
                    <v-text-field prepend-icon="person" name="login" label="Login"></v-text-field>
                  </w-schema>

                  <w-schema :model="$schema.password">
                    <v-text-field
                      prepend-icon="lock"
                      name="password"
                      label="Hasło"
                      id="password"
                      hint="Minimum 8 znaków"
                      :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                  </w-schema>
                </v-card-text>

                <v-card-actions class="text-xs-center">
                  <v-btn
                    depressed
                    large
                    dark
                    round
                    type="submit"
                    color="primary"
                    style="margin:auto"
                  >Zaloguj się</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { WSchema, schemaMixin } from '@witkac/vuetify-components';

import store from '@/store/store';
import schema from '@/schemas/login.schema';
import HeaderSimple from '@/components/layout/HeaderSimple';

// @vuese
// Formularz logowania
// @group Auth
export default {
  mixins: [schemaMixin],
  components: { WSchema, HeaderSimple },
  data() {
    return {
      showPassword: false,
      showError: false,
      errorMessage: undefined,
      model: {
        login: '',
        password: ''
      }
    };
  },
  schema,
  beforeRouteEnter(to, from, next) {
    store
      .dispatch('settings/get', 'PUBLIC_CLIENT_REGISTER_TEXT')
      .then(() => next())
      .catch(err =>
        store.dispatch('notifyError', {
          title: 'Wystąpił błąd podczas pobierania ustawień.',
          messages: [error.message || error]
        })
      );
  },
  methods: {
    // @vuese
    // Metoda próbuje zalogować użytkownika po podanych danych
    async tryToLogin() {
      const errors = this.$schema.$validateAll();
      if (errors.length) {
        return;
      }
      this.$store
        .dispatch('auth/login', {
          login: this.model.login,
          password: this.model.password
        })
        .then(hasAllConsents =>
          this.$router.push({ name: hasAllConsents ? 'home' : 'consents' })
        )
        .catch(error => (this.errorMessage = error.message || error));
    }
  },
  watch: {
    errorMessage(val) {
      if (val) {
        this.showError = true;
      }
    },
    showError(val) {
      if (!val) {
        this.errorMessage = undefined;
      }
    }
  },
  computed: mapState({
    system: state => state.system,
    settings: state => state.settings
  })
};
</script>
<style>
</style>